import React from "react";
import moment from "moment-timezone";
import { Icon } from "semantic-ui-react";
import styled from "styled-components";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.bubble.css";
import { Timeline, TimelineEvent } from "react-event-timeline";
import { get } from "../../services/storage";

export type MessageType = {
  text:
    | boolean
    | React.ReactChild
    | React.ReactFragment
      | React.ReactPortal
      | null
      | undefined;
  pendingResponsible?: string | null;
  pendingType?: string | null;
  pending_responsible?: string | null;
  pending_type?: string | null;
  senderId: {
    name:
      | boolean
      | React.ReactChild
      | React.ReactFragment
      | React.ReactPortal
      | null
      | undefined;
  };
  createdAt: moment.MomentInput;
};

const ContainerInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Div = styled.div`
overflow-y: "scroll";
strong {
  font-weight: bold;
}
`;

const MessageTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
`;

const PendencyInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #707682;
  font-size: 12px;
  font-weight: 400;
`;

const PendencyBadge = styled.span<{ $filled?: boolean; $accentColor: string }>`
  border: 1px solid ${props => props.$accentColor};
  border-radius: 999px;
  background: ${props => (props.$filled ? props.$accentColor : "#ffffff")};
  color: ${props => (props.$filled ? "#ffffff" : props.$accentColor)};
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  padding: 5px 12px;
`;

const MessagesList = (props: any) => {
  const { messages } = props;
  const accentColor = props.accentColor || "#5C6BC0";
  console.log("MSG", messages);

  const userName = get("name");

  const getPendencyResponsible = (message: MessageType) =>
    message.pendingResponsible || message.pending_responsible;

  const getPendencyType = (message: MessageType) =>
    message.pendingType || message.pending_type;

  return (
    <Div>
      <Timeline>
        {messages.map((message: MessageType) => {
          return (
            <TimelineEvent
              title={
                <MessageTitle>
                  <span>{message.senderId.name ? message.senderId.name : userName}</span>
                  {(getPendencyResponsible(message) || getPendencyType(message)) && (
                    <PendencyInfo>
                      <span>Pendência:</span>
                      {getPendencyResponsible(message) && (
                        <PendencyBadge $filled $accentColor={accentColor}>
                          {getPendencyResponsible(message)}
                        </PendencyBadge>
                      )}
                      {getPendencyType(message) && (
                        <PendencyBadge $accentColor={accentColor}>
                          {getPendencyType(message)}
                        </PendencyBadge>
                      )}
                    </PendencyInfo>
                  )}
                </MessageTitle>
              }
              createdAt={moment(message.createdAt).format("DD/MM/YY - HH:mm")}
              icon={<Icon name="envelope open outline" size="large" />}
              iconColor={accentColor}
              style={{
                backgroundColor: "#fff",
                padding: 10,
                boxShadow: `0 0 3px 1px ${accentColor}`,
                fontSize: "12px",
              }}
              iconStyle={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: 2,
              }}
              contentStyle={{
                backgroundColor: "#FEFEFE",
                color: accentColor,
                fontSize: "16px",
              }}
            >
              <ReactQuill
                theme="bubble"
                value={(message.text as string) || ""}
                readOnly={true}
              />
            </TimelineEvent>
          );
        })}
      </Timeline>
    </Div>
  );
};

export default MessagesList;

{
  /* <Item.Group>
      {messages.map((message: MessageType) => {
        return (
          <Item>
            <Item.Content>
              <Item.Header>{message.text}</Item.Header>
              <ContainerInfo>
                <Item.Meta><span>{moment(message.createdAt).format('DD/MM/YY - HH:mm:ss')}</span></Item.Meta>
                <Item.Description><p>{message.senderId.name}</p></Item.Description>
              </ContainerInfo>
            </Item.Content>
          </Item>
        )
      })}
    </Item.Group> */
}
